module.exports = __webpack_public_path__ + "media/images/flashcards_digital-6f4ad4d0.svg";